import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getGuideList as getGuideListApi,
	getGuidesFlat as getGuidesFlatApi,
	getGuide as getGuideApi,
	addNewGuide as addNewGuideApi,
	updateGuide as updateGuideApi,
	deleteGuide as deleteGuideApi,
	cancelWarehouseSendFromStock as cancelWarehouseSendFromStockApi,
	cancelGuideLinesSend as cancelGuideLinesSendApi,
	getRegisterGuide as getRegisterGuideApi,
	registerGuide as registerGuideApi,
	finalDestinationReceptionGuide as finalDestinationReceptionGuideApi,
	finalDestinationPrecertificationGuide as finalDestinationPrecertificationGuideApi,
	finalDestinationCertificationGuide as finalDestinationCertificationGuideApi,
	warehouseReceptionGuide as warehouseReceptionGuideApi,
	warehouseSendGuide as warehouseSendGuideApi,
	statementGuide as statementGuideApi,
	getDetailGuide as getDetailGuideApi,
	getFolderPaths as getFolderPathsApi,
	getStatusGuide as getStatusGuideApi,
} from '../../helpers/residue/backend_helper';

export const getGuideList = createAsyncThunk('guides/getGuideList', async (params) => {
	try {
		const response = getGuideListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuidesFlat = createAsyncThunk('guides/getGuidesFlat', async (params) => {
	try {
		const response = await getGuidesFlatApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuide = createAsyncThunk('guides/getGuide', async guide_id => {
	try {
		const response = getGuideApi(guide_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getDetailGuide = createAsyncThunk('guides/getDetailGuide', async guide_id => {
	try {
		const response = getDetailGuideApi(guide_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewGuide = createAsyncThunk('guides/addNewGuide', async guide => {
	try {
		const response = addNewGuideApi(guide);
		toast.success('Guide agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar guide.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateGuide = createAsyncThunk('guides/updateGuide', async (guide) => {
		try {
			const response = updateGuideApi(guide);
			toast.success('Guide actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar guide.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteGuide = createAsyncThunk('guides/deleteGuide', async guide => {
	try {
		const response = await deleteGuideApi(guide);
		toast.success('Guide eliminado exitosamente.', { autoClose: 3000 });
		return { guide, ...response };
	} catch (error) {
		toast.error('Error al eliminar guide.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const cancelWarehouseSendFromStock = createAsyncThunk(
	'guides/cancelWarehouseSendFromStock',
	async ({ guideId, mode, reason }) => {
		try {
			const response = await cancelWarehouseSendFromStockApi(guideId, {
				mode,
				reason,
			});
			toast.success('Envío desde bodega anulado correctamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			const detail =
				error?.response?.data?.detail ||
				error?.message ||
				'Error al anular envío desde bodega';
			toast.error(detail, { autoClose: 5000 });
			throw error;
		}
	},
);

export const cancelGuideLinesSend = createAsyncThunk(
	'guides/cancelGuideLinesSend',
	async ({ guideId, mode, reason }) => {
		try {
			const response = await cancelGuideLinesSendApi(guideId, {
				mode,
				reason,
			});
			toast.success('Envío NP desde guías anulado correctamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			const detail =
				error?.response?.data?.detail ||
				error?.message ||
				'Error al anular envío desde líneas de guía';
			toast.error(detail, { autoClose: 5000 });
			throw error;
		}
	},
);

export const getRegisterGuide = createAsyncThunk('guides/getRegisterGuide', async guide => {
	try {
		const response = getRegisterGuideApi(guide);
		console.log(response)
		// toast.success('Guía cargada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		console.log(error)
		toast.error('Error al obtener datos de guía.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const registerGuide = createAsyncThunk('guides/registerGuide', async guide => {
	try {
		const response = await registerGuideApi(guide);
		toast.success(`Guía ${guide?.id ? 'actualizada' : 'registrada'} exitosamente.`, { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al registrar guía de residuos.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const finalDestinationReceptionGuide = createAsyncThunk('guides/finalDestinationReceptionGuide', async dataGuides => {
	try {
		const response = await finalDestinationReceptionGuideApi(dataGuides);
		toast.success('Guías recepcionadas exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al recepcionar guías.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const finalDestinationPrecertificationGuide = createAsyncThunk('guides/finalDestinationPrecertificationGuide', async dataGuides => {
	try {
		const response = await finalDestinationPrecertificationGuideApi(dataGuides);
		toast.success('Guías precertificadas exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al recepcionar guías.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const finalDestinationCertificationGuide = createAsyncThunk('guides/finalDestinationCertificationGuide', async dataGuides => {
	try {
		const response = await finalDestinationCertificationGuideApi(dataGuides);
		toast.success('Guías certificadas exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al recepcionar guías.', { autoClose: 3000 });
		throw new Error(error);
	}
});


export const warehouseReceptionGuide = createAsyncThunk('guides/warehouseReceptionGuide', async dataGuides => {
	try {
		const response = await warehouseReceptionGuideApi(dataGuides);
		toast.success('Residuos recepcionados exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al recepcionar residuos.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const warehouseSendGuide = createAsyncThunk('guides/warehouseSendGuide', async dataGuides => {
	try {
		const response = await warehouseSendGuideApi(dataGuides);
		toast.success('Residuos enviados exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al enviar residuos.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const statementGuide = createAsyncThunk('guides/statementGuide', async dataGuides => {
	try {
		const response = await statementGuideApi(dataGuides);
		toast.success('Guías declaradas exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al declarar guías.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getFolderPaths = createAsyncThunk('guides/getFolderPaths', async (data) => {
    try {
        const response = await getFolderPathsApi(data);
        // toast.success('Carpetas obtenidas exitosamente.', { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error('Error al obtener folder paths.', { autoClose: 3000 });
        throw new Error(error.message);
    }
});

export const getStatusGuide = createAsyncThunk('guides/getStatusGuide', async (params) => {
    try {
        const response = await getStatusGuideApi(params);
        return response;
    } catch (error) {
        toast.error('Error al obtener folder paths.', { autoClose: 3000 });
        throw new Error(error.message);
    }
});